var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49992 16.586L4.70692 12.793C4.51832 12.6109 4.26571 12.5101 4.00352 12.5124C3.74132 12.5146 3.49051 12.6198 3.3051 12.8052C3.11969 12.9906 3.01452 13.2414 3.01224 13.5036C3.00997 13.7658 3.11076 14.0184 3.29292 14.207L7.79292 18.707C7.98045 18.8945 8.23475 18.9998 8.49992 18.9998C8.76508 18.9998 9.01939 18.8945 9.20692 18.707L20.2069 7.70704C20.3891 7.51844 20.4899 7.26584 20.4876 7.00364C20.4853 6.74144 20.3801 6.49063 20.1947 6.30522C20.0093 6.11981 19.7585 6.01465 19.4963 6.01237C19.2341 6.01009 18.9815 6.11088 18.7929 6.29304L8.49992 16.586Z",
    fill: "#128087"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/CheckIcon.cf8d8f827f7e82cb5f0679ea9e522dbf.svg";
export { ForwardRef as ReactComponent };